module.exports = __webpack_public_path__ + "cancellara-dist/img/unindustria.b476c43b.png";